import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS } from "../lib/site";

export default function Policies() {
  const { settings } = useSite();
  const sections = [
    {
      id: "cancellation",
      title: "Cancellation & Amendments",
      items: [
        settings.cancellation_policy || "Free cancellation or amendment up to 72 hours before your check-in date.",
        "Cancellations within 72 hours of arrival are charged at one night's rate.",
        "No-shows and early departures are charged at the full booked stay.",
        "Date changes are complimentary once per booking, subject to availability.",
        "Refunds, where applicable, are processed to the original payment account within 7–10 working days.",
      ],
    },
    {
      id: "terms",
      title: "Terms of Stay",
      items: [
        `Check-in from ${settings.checkin_time || "2 PM"}; check-out until ${settings.checkout_time || "12 PM"}. Early arrival and late departure are subject to availability.`,
        "A valid government photo ID is required for every adult guest at check-in.",
        "Reservations are confirmed on receipt of the advance payment to our Indian Bank current account or UPI.",
        "Rates include breakfast for two and all applicable taxes unless stated otherwise.",
        "Pets are welcome on request in select cottages; smoking is permitted in designated outdoor areas only.",
      ],
    },
  ];
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[2]}
        eyebrow="Policies"
        lines={[<>Clear terms,</>, <em>warm stays.</em>]}
        lede="Everything about cancellations, your stay and your privacy — written plainly, because trust starts before check-in."
      />
      <section className="section-pad intro" data-testid="policies-sections">
        {sections.map((section) => (
          <Reveal key={section.id} className="policy-block" data-testid={`policy-${section.id}`}>
            <h2 id={section.id}>{section.title}</h2>
            <ul>
              {section.items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </Reveal>
        ))}
        <Reveal className="policy-block">
          <p className="muted" data-testid="policies-privacy-note">
            Looking for how we handle your data? Read our <Link to="/privacy" className="text-link" data-testid="policies-privacy-link">Privacy Policy</Link>.
          </p>
        </Reveal>
      </section>
    </main>
  );
}
